import { render, staticRenderFns } from "./Certform.vue?vue&type=template&id=5ed0c727&scoped=true&"
import script from "./Certform.vue?vue&type=script&lang=js&"
export * from "./Certform.vue?vue&type=script&lang=js&"
import style0 from "./Certform.vue?vue&type=style&index=0&id=5ed0c727&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed0c727",
  null
  
)

export default component.exports